// extracted by mini-css-extract-plugin
export default {"skeleton":"SignModal_skeleton__QEe4N","actions":"SignModal_actions__Y3gW1","action-button":"SignModal_action-button__84W28"};